module.exports = __webpack_public_path__ + "img/alert-icon.5d82be5f.svg";